<panel>
  <h1>{{ 'mail-template.list-templates' | translate }}</h1>
  @if (loading) {
    <div>
      <skeletons [defaultSkeletons]="4" />
    </div>
  }
  @if (!loading) {
    <list-view [emptyLabel]="'mail-template.template-list-empty-label'">
      <header defaultSort="ascending">{{ 'mail-template.list-template.title' | translate }}</header>
      <header>{{'mail-template.list-template.type' | translate }}</header>
      <header></header>
      <row *listData="let mailTemplate from mailTemplates" [highlighted]="selectedMailTemplate == mailTemplate" (action)="displayMailTemplate(mailTemplate)">
        <column>{{ mailTemplate.title}}</column>
        <column>{{ (templateType[mailTemplate.mailTemplateType] ? 'enum.list-mail-templates.' + templateType[mailTemplate.mailTemplateType] : 'general.na') | translate }}</column>
        <column align-right>@if (mailTemplate.mailTemplateType == 0) {
        <icon (click)="deleteMailTemplate(mailTemplate)" type="trash" small />
      }</column>
    </row>
  </list-view>
}
<section>
  <button [loader]="false" (click)="createMailTemplate()">{{ 'general.create' | translate }}</button>
</section>
</panel>
